<template>
    <div class="agree-modal">
        <common-header left-div="blank" right-div="close" title="분할 자동결제 안내" v-on:closeEvent="closeModal" />

        <ion-content padding>
            <div class="content">
                <div class="payment-description refund-rule-component mt-3">
                    <div>
                        <div>신용카드를 등록하면 매월 분할하여 자동결제가 됩니다.</div>
                        <br>

                        <div class="checked-comment">
                            <div class="payment-description ml-3">
                                <div class="format1"><span class="mark">*</span>6개월 약정 결제 시: 매월 69,000원 자동결제 (무이자 6회납부)</div>
                                <div class="format1"><span class="mark">*</span>12개월 약정 결제 시: 매월 59,000원 자동결제 (무이자 12회납부)</div>
                                <br>
                                <div class="format1"><span class="mark">※</span>예) 9월5일에 6개월 약정을 신용카드로 결제 할 경우</div>
                                <div class="format1"><span class="mark">-</span>1회차: 9/5 = 69,000원 카드 자동결제</div>
                                <div class="format1"><span class="mark">-</span>2회차: 10/5 = 69,000원 카드 자동결제</div>
                                <div class="format1"><span class="mark">-</span>3회차: 11/5 = 69,000원 카드 자동결제</div>
                                <div class="format1"><span class="mark">-</span>4회차: 12/5 = 69,000원 카드 자동결제</div>
                                <div class="format1"><span class="mark">-</span>5회차:  1/5 = 69,000원 카드 자동결제</div>
                                <div class="format1"><span class="mark">-</span>6회차:  2/5 = 69,000원 카드 자동결제</div>
                            </div>
                        </div>
                        <br>
                        <div>이용권은 회차별 1개월 이용권이 자동으로 발급됩니다.</div>
                    </div>
                </div>
            </div>
        </ion-content>

        <footer-one-buttonbar label="확인" v-bind:is-fixed="true" v-on:footerButtonEvent="agreeClickEvent" />
    </div>
</template>

<script>
import { eventBus } from "./Payment"

import CommonHeader from "../../components/header/CommonHeader";
import FooterOneButtonbar from "../../components/footer/FooterOneButtonbar";

export default {
    name: 'RepeatPaymentIntroduceModal',
    components: {CommonHeader, FooterOneButtonbar},
    props: [],
    data() {
        return {
        }
    },
    methods: {
        closeModal() {
            this.$ionic.modalController.dismiss('cancel');
        },
        agreeClickEvent() {
            eventBus.$emit('agreement');
            this.$ionic.modalController.dismiss();
        }
    }
}
</script>

<style scoped lang="scss">
ion-content {
    background-color: $seventh-color;

    div.title {
        margin: 10px 0 30px 0;
        font-weight: $font-weight500;
    }

    div.content {
        margin-bottom: 70px;
        padding: 0 5px 20px 20px;
        min-height: 100%;
        background-color: white;
        font-size: $font-base14;
        color: $font-third-color;
    }
}
</style>
